import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ErrorPopup from "../Components/ErrorPopup";
import SweetAlert from "react-bootstrap-sweetalert";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

class DiscoverDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      subscriptionLevel: "",
      openErrorPopup: false,
    };
  }

  componentDidMount() {
    const loginSubs = this.props?.reduxData?.loginSubscriptionDetail || [];
    const activeSubscription = loginSubs.find(item => item.attributes?.active === true) || { id: 0 };
    this.setState({
      subscriptionLevel: activeSubscription?.attributes?.plan?.toLowerCase(),
    });
  }

  handleMouseEnter = () => {
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout);
      this.leaveTimeout = null;
    }
    const isModalOpen = document.body.classList.contains('modal-is-open') || document.querySelector('.modal-overlay') !== null;
    if (!isModalOpen) {
      this.setState({ dropdownOpen: true });
    }
  };

  handleMouseLeave = () => {
    this.leaveTimeout = setTimeout(() => {
      this.setState({ dropdownOpen: false });
    }, 200);
  };

  closeDropdowns = () => {
    this.setState({ dropdownOpen: false });
  };

  toggleDropdown = () => {
    // Don't toggle dropdown if a modal is currently open
    const isModalOpen = document.body.classList.contains('modal-is-open') || document.querySelector('.modal-overlay') !== null;
    if (!isModalOpen) {
      this.setState((prevState) => ({
        dropdownOpen: !prevState.dropdownOpen,
        nestedDropdownOpen: false,
      }));
    }
  };

  componentWillUnmount() {
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.closeDropdowns();
    }
  }

  handleItemClick = (path) => {
    if (path.startsWith("http")) {
        window.open(path, "_blank", "noopener noreferrer");
      } else {
        this.props.history.push(path);
      }
    // if (this.state.subscriptionLevel === "gold") {
    //   if (path.startsWith("http")) {
    //     window.open(path, "_blank", "noopener noreferrer");
    //   } else {
    //     this.props.history.push(path);
    //   }
    // } else {
    //   this.setState({ openErrorPopup: true });
    // }
  };

  closePopup = () => {
    this.setState({ openErrorPopup: false });
  };

  render() {
    const { dropdownOpen } = this.state;
    const { location } = this.props;

    const isActive = location.pathname.includes("discover");

    const dropdownItems = [
      { path: "/app/discover/myProject", label: "Network Analysis" },
      { path: "https://clue.io/", label: "CMap" },
      {
        path: "https://mergeomics.research.idre.ucla.edu/runpharmomics.php",
        label: "PharmOmics",
      },
      { path: "/app/discover/discover&Repurposing", label: "Compound Evaluation" },
    ];

    return (
      <Dropdown
        isOpen={dropdownOpen}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        toggle={this.toggleDropdown}
      >
        <DropdownToggle tag="div" aria-expanded={dropdownOpen}>
          <div
            className={`btn-link-primary ${isActive ? "link-active" : "link-inactive"
              }`}
            style={{ cursor: "pointer" }}
            onClick={() => {
              this.props.history.push("/app/discover/myProject");
              // if (this.state.subscriptionLevel === "gold") {
              //   this.props.history.push("/app/discover/myProject");
              // } else {
              //   this.setState({ openErrorPopup: true });
              // }
            }}
          >
            <span className="header-nav-label">
              Multi-Omics Network Analysis
            </span>
          </div>
        </DropdownToggle>
        <DropdownMenu>
          {dropdownItems.map((item, index) => (
            <DropdownItem
              key={index}
              className="custom-dropdown-item"
              onClick={() => this.handleItemClick(item.path)}
            >
              {item.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
        <SweetAlert
          custom
          show={this.state.openErrorPopup}
          customButtons={<React.Fragment></React.Fragment>}
          style={{ width: "auto", padding: "1rem" }}
        >
          <ErrorPopup
            closeAlert={this.closePopup}
            title="Access to this feature is exclusive to Gold members. Please update your subscription to gain access."
            buttonTitle="Ok"
          ></ErrorPopup>
        </SweetAlert>
      </Dropdown>
    );
  }
}

export default connect(mapStateToProps)(withRouter(DiscoverDropdown));
